import { subTopicos } from '../../../styles';
import { openMergePDFInNewTab } from './DownloadMerge';

export const BuscaMerge = ({ mergedDocs }) => {
  // 🔎 Filtra apenas os que NÃO estão cancelados
  const activeMerges = mergedDocs.filter(
    (item) => item.is_cancelado === false
  );

  return (
    <>
      {activeMerges.length > 0 ? (
        activeMerges.map((item) => (
          <div key={item.id} style={subTopicos.documentDiv}>
            <span
              style={{
                color: 'var(--info)',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '8pt',
              }}
              onClick={() => openMergePDFInNewTab(item.id)}
            >
              (Documento mesclado: {item.file_name})
            </span>
          </div>
        ))
      ) : (
        <div style={{ fontStyle: 'italic', color: 'var(--text-muted)' }}>
          Nenhum documento mesclado
        </div>
      )}
    </>
  );
};